<div class="layout-footer">
  {{ footerTitle }} by
  <a href="https://blistertechnologies.com" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">
    Blister Technologies SRL.
  </a>
</div>
  